import { IReportsRepository } from "../../repositories/reports_repository";
import { IGetReportFolhaPagamentoUseCase } from "../../../presentation/useCases/read/get_report_folha_pagamento_use_case";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";

/**
 * GetReportFolhaPagamentoUseCase
 */

export class GetReportFolhaPagamentoUseCase implements IGetReportFolhaPagamentoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportFolhaPagamento(
    requiredMimeType: ReportMimeType | null,
    titulo: string | null,
    subcontas: number[] | null,
    folhaPagamentos: number[] | null,
    centroCustos: number[] | null,
    funcionarios: number[] | null,
    bancoPagamentos: number[] | null,
    status: number[] | null,
    dataPagarDe: Date | null,
    dataPagarAte: Date | null,
    dataPagoDe: Date | null,
    dataPagoAte: Date | null,
    colunas: {
      nro: boolean,
      centroCusto: boolean,
      folhaPagamento: boolean,
      funcionarioFolha: boolean,
      bancoPagamento: boolean,
      notaFiscal: boolean,
      nroDoc: boolean,
      responsavel: boolean,
      status: boolean,
      titulo: boolean,
      subConta: boolean,
      dataPagar: boolean,
      dataPago: boolean,
      valorPagar: boolean,
      valorPago: boolean,
      observacoes: boolean,
    },
  ): Promise<ReportData> {
    const response = await this.repository.getReportFolhaPagamento(
      requiredMimeType,
      titulo,
      subcontas,
      folhaPagamentos,
      centroCustos,
      funcionarios,
      bancoPagamentos,
      status,
      dataPagarDe,
      dataPagarAte,
      dataPagoDe,
      dataPagoAte,
      colunas,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `folha_pagamento_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
